














import { Component, Prop, Vue } from "vue-property-decorator";
import { Letter } from "@/models/definitions";

import Memory from "@/components/dynamic/Memory.vue";

@Component({
  components: {
    Memory,
  },
})
export default class Paper extends Vue {
  @Prop({ required: true }) readonly letter!: Letter;

  private unsealed = false;

  mounted() {
    // refresh cookie
    if (this.isMarkedUnsealed()) {
      this.markUnsealed();
    }

    this.bindDynamicComponents();
  }

  get sealed() {
    return !this.isMarkedUnsealed();
  }

  get isSealed() {
    return this.sealed && !this.unsealed;
  }

  private isMarkedUnsealed(): boolean {
    return this.$cookies.isKey("letter-" + this.letter.id);
  }

  private markUnsealed() {
    this.$cookies.set("letter-" + this.letter.id, true);
  }

  private unseal() {
    this.unsealed = true;
    this.markUnsealed();
  }

  private bindDynamicComponents() {
    const posts = this.$refs.posts as Element;

    const componentContainers = posts.querySelectorAll("div.dynamic-component");
    componentContainers.forEach((container) => {
      const componentName = container.getAttribute("data-component");

      const component = import(`@/components/dynamic/${componentName}.vue`);
      component
        .then((component) => {
          try {
            const instance = new component.default();
            instance.$mount();
            container.appendChild(instance.$el);
          } catch (error) {
            console.error(error);
          }
        })
        .catch((reason) => console.log(reason));
    });

    return;
  }
}
